import { base } from "@/components/Tools/FormHelperFactory/Configurations/baseConfigurations";

export const checkbox = {
  ...base,
  switch: {
    type: "checkbox",
    default: true
  }
};
